import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  padding: 0 20px 80px 20px;
  position: relative;
  min-width: 1140px;
`;

export const HeaderContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
`;

export const SubHeaderContainer = styled.div`
  box-sizing: border-box;
  padding: 0px 24px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

export const ContentContainer = styled.div`
  box-sizing: border-box;
  padding: 0px 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const EmptyRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const FooterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
`;